var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBatteryfull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08911 1.78218L9.08911 2.55446L8.37624 2.55446C7.74624 2.55517 7.14224 2.80575 6.69676 3.25122C6.25129 3.6967 6.00071 4.3007 6 4.93069L6 21.6238C6.00071 22.2538 6.25129 22.8578 6.69676 23.3032C7.14224 23.7487 7.74624 23.9993 8.37624 24L16.5743 24C17.2043 23.9993 17.8082 23.7487 18.2537 23.3032C18.6992 22.8578 18.9498 22.2538 18.9505 21.6238L18.9505 4.93069C18.9498 4.30069 18.6992 3.6967 18.2537 3.25122C17.8082 2.80575 17.2043 2.55517 16.5743 2.55446L15.8614 2.55446L15.8614 1.78218C15.8614 0.799488 15.1629 1.50682e-06 14.3045 1.54435e-06L10.646 1.70427e-06C9.78754 1.74179e-06 9.08911 0.799488 9.08911 1.78218ZM16.5743 3.74258C16.8892 3.74294 17.1912 3.86823 17.414 4.09097C17.6367 4.3137 17.762 4.6157 17.7624 4.93069L17.7624 21.6238C17.762 21.9388 17.6367 22.2408 17.414 22.4635C17.1912 22.6862 16.8892 22.8115 16.5743 22.8119L8.37624 22.8119C8.06124 22.8115 7.75925 22.6862 7.53651 22.4635C7.31377 22.2408 7.18848 21.9388 7.18812 21.6238L7.18812 4.93069C7.18848 4.6157 7.31377 4.31371 7.53651 4.09097C7.75925 3.86823 8.06124 3.74294 8.37624 3.74258L16.5743 3.74258ZM14.3045 1.18812C14.4786 1.18812 14.6733 1.44214 14.6733 1.78218L14.6733 2.55446L10.2772 2.55446L10.2772 1.78218C10.2772 1.44214 10.4719 1.18812 10.646 1.18812L14.3045 1.18812Z",
    fill: "#2C2C2C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 6,
    width: 8,
    height: 1.3,
    fill: "#2C2C2C",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 10,
    width: 8,
    height: 1.3,
    fill: "#2C2C2C",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 14,
    width: 8,
    height: 1.3,
    fill: "#2C2C2C",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 18,
    width: 8,
    height: 1.3,
    fill: "#2C2C2C",
    rx: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBatteryfull);
export default __webpack_public_path__ + "static/media/ic_batteryfull.faf5102b7a92ddc3e3271cf23ac54da1.svg";
export { ForwardRef as ReactComponent };